export default __webpack_public_path__ + "static/media/undraw_add_file2_gvbb.612f0abb.svg";